// @flow

import React, { Component, Fragment } from 'react'
import type { Room as RoomType } from 'types/room'
import ImageGallery from 'lib/ImageGallery'
import ReputationStar from 'components/shared/ReputationStar'
import Path from 'routes/path'
import { imagePath } from 'frontend_core/dist/helpers/image'

type PropTypes = {
  room: RoomType,
  addedFavoriteListName?: ?string,
  showingFavoriteListTooltipList: Array,
  onClickFavorite: Function,
  cantFavorite?: boolean,
}

export default class RoomCardSliderItem extends Component<*> {
  imageGallery: ImageGallery
  props: PropTypes

  nextImage = (e: Event) => {
    e.preventDefault()
    if (this.imageGallery) {
      this.imageGallery._slideRight()
    }
  }

  prevImage = (e: Event) => {
    e.preventDefault()
    if (this.imageGallery) {
      this.imageGallery._slideLeft()
    }
  }

  render() {
    const {
      room,
      addedFavoriteListName,
      cantFavorite,
      showingFavoriteListTooltipList,
    } = this.props
    const { prices, space, isFavorite, id } = room
    const price = prices[0] || {}

    if (!room || !space) {
      return null
    }

    if (room.isPaddingCard) {
      return null
    }

    const roomPath = Path.room(space.username, room.uid)

    return (
      <Fragment>
        <div className="units-item__image">
          <ImageGallery
            ref={ref => {
              this.imageGallery = ref
            }}
            items={room.thumbnails.results}
            infinite
            lazyLoad
            showPlayButton={false}
            showFullscreenButton={false}
            showThumbnails={false}
            showNav={false}
            useTranslate3D={false}
            slideDuration={0}
            defaultImage={imagePath('noimage_search.png')}
            renderItem={item => (
              <a href={roomPath}>
                <img
                  src={item.url}
                  alt=""
                  className="units-item__image-pict is-hover"
                />
              </a>
            )}
          />
          <a
            href="#"
            onClick={this.nextImage}
            aria-label="previous"
            className="units-item__image-prev is-hover"
          >
            <i className="fa fa-chevron-left" />
          </a>
          <a
            href="#"
            onClick={this.prevImage}
            aria-label="next"
            className="units-item__image-next is-hover"
          >
            <i className="fa fa-chevron-right" />
          </a>
          {!cantFavorite && (
            <a
              href="#"
              onClick={this.props.onClickFavorite}
              aria-label="favorit"
              className={`units-item-fav${isFavorite ? '__on' : ''}`}
            >
              <i className="fa fa-heart" />
            </a>
          )}
          {showingFavoriteListTooltipList &&
            showingFavoriteListTooltipList.includes(id) && (
              <div className="units-item__baloon">
                <p className="units-item__baloon-text">
                  {addedFavoriteListName}
                </p>
              </div>
            )}
          <p className="units-item__item-price">
            {price.minText}
            {price.minUnitText && (
              <span className="units-item__item-per">
                {`/${price.minUnitText}`}
              </span>
            )}
            {price.maxText && (
              <React.Fragment>
                <span className="units-item__item-per">〜</span>
                {price.maxText}
              </React.Fragment>
            )}
            {price.maxUnitText && (
              <span className="units-item__item-per">
                {`/${price.maxUnitText}`}
              </span>
            )}
            <span className="units-item__price-icon">
              {room.hasDirectReservationPlans && (
                <i className="fa fa-bolt units-item__price-icon-instant" />
              )}
              {room.hasLastMinuteDiscountPlans && (
                <i className="mr5 icon icon-spm-discount icon-discount" />
              )}
              {room.owner.rank === 1 && (
                <span className="icon-spm-top_host units-item__price-icon-top-host" />
              )}
            </span>
          </p>
        </div>
        <div className="units-item__body">
          <div className="units-item__body-inner link__subcolor">
            <h3 className="units-item__body-title">
              <a href={roomPath}>{room.name}</a>
            </h3>
            <ul className="units-item__body-info">
              <li>
                <i className="fa fa-user mr5" />
                <a href={Path.capacity(room.capacity)}>
                  {i18n.t('page.room.capacity', { capacity: room.capacity })}
                </a>
              </li>
              <li>
                <i className="fa fa-map-marker mr5" />
                <a href={Path.area(`${space.state}/${space.city}`)}>
                  {space.stateText}
                </a>
              </li>
              <li>
                <ReputationStar
                  score={room.reputationScore}
                  linkUrl={Path.roomReputationList(space.username, room.uid)}
                />
                <a
                  href={Path.roomReputationList(space.username, room.uid)}
                  className=""
                >
                  {room.reputationsCount}
                  {i18n.t('page.search.resultCountUnit')}
                </a>
              </li>
            </ul>
          </div>
          <p className="units-item__body-access">{space.access}</p>
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/room/RoomCardSliderItem/index.jsx